"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _flyout = require("../../flyout");

var _layout = require("../../layout");

var _popover = require("../../popover");

var _constants = require("../../popover/constants");

var _responsive = require("../../responsive");

var _utils = require("../../utils");

var _dateInputField = require("../date-input-field");

var _AccessibleDatePickerButton = require("./AccessibleDatePickerButton");

var _constants2 = require("./constants");

var _core = require("@emotion/core");

var _excluded = ["calendarButtonAltText", "clearButtonAltText", "collapsedTitleText", "collapsedCloseButtonAltText", "disabled", "inputProps", "inputRef", "onInputChange", "onInputError", "popoverProps", "renderPopupContent"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DateInputWithPopup = function DateInputWithPopup(_ref) {
  var calendarButtonAltText = _ref.calendarButtonAltText,
      clearButtonAltText = _ref.clearButtonAltText,
      collapsedTitleText = _ref.collapsedTitleText,
      collapsedCloseButtonAltText = _ref.collapsedCloseButtonAltText,
      disabled = _ref.disabled,
      inputProps = _ref.inputProps,
      inputRef = _ref.inputRef,
      onInputChange = _ref.onInputChange,
      onInputError = _ref.onInputError,
      popoverProps = _ref.popoverProps,
      renderPopupContent = _ref.renderPopupContent,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var viewport = (0, _responsive.useBreakpoints)();

  var renderInput = function renderInput(_ref2) {
    var isOpen = _ref2.isOpen,
        isReadOnly = _ref2.isReadOnly,
        toggle = _ref2.toggle;
    var dataProps = (0, _utils.pickDataProps)(forwardedProps);
    var parentInsetElement = disabled ? undefined : (0, _core.jsx)(_AccessibleDatePickerButton.AccessibleDatePickerButton, {
      calendarButtonAltText: calendarButtonAltText,
      isOpen: isOpen,
      toggle: toggle
    });
    return (0, _core.jsx)(_dateInputField.DateInputField, (0, _extends2.default)({}, inputProps, dataProps, {
      clearButtonAltText: clearButtonAltText,
      disabled: disabled,
      isCalendarOpen: isOpen,
      onChange: onInputChange,
      onClick: toggle,
      onError: onInputError,
      parentInsetElement: parentInsetElement,
      readOnly: isReadOnly,
      ref: inputRef
    }));
  };

  var renderFlyout = function renderFlyout() {
    return (0, _core.jsx)(_flyout.WithFlyout, {
      renderFlyout: function renderFlyout(_ref3) {
        var close = _ref3.close;
        return (0, _core.jsx)(_layout.View, {
          width: "100vw",
          height: "100vh"
        }, (0, _core.jsx)(_flyout.FlyoutContent, {
          closeButtonAltText: collapsedCloseButtonAltText,
          maxWidth: null,
          onCloseButtonClick: close,
          titleText: collapsedTitleText
        }, renderPopupContent(close)));
      },
      zIndex: "highest"
    }, function (_ref4) {
      var open = _ref4.open;
      return renderInput({
        isOpen: false,
        isReadOnly: true,
        toggle: open
      });
    });
  };

  var renderPopover = function renderPopover() {
    var handleClose = function handleClose() {
      setIsOpen(false);
    };

    var handleToggle = function handleToggle(event) {
      event && event.stopPropagation();
      setIsOpen(!isOpen);
    };

    var handlePopoverEscKey = function handlePopoverEscKey() {
      inputRef && inputRef.current && inputRef.current.focus();
    };

    return (0, _core.jsx)(_react.default.Fragment, null, renderInput({
      isOpen: isOpen,
      isReadOnly: false,
      toggle: handleToggle
    }), (0, _core.jsx)(_popover.PopoverController, (0, _extends2.default)({}, popoverProps, {
      close: handleClose,
      isOpen: isOpen,
      onEscKey: handlePopoverEscKey,
      target: inputRef
    }), (0, _core.jsx)(_layout.View, {
      width: _constants2.POPOVER_WIDTH,
      borderRadius: _constants.POPOVER_BODY_RADIUS,
      overflow: "hidden"
    }, renderPopupContent(handleClose))));
  };

  return viewport.matches.s ? renderFlyout() : renderPopover();
};

var _default = (0, _utils.withTestAttributes)({})(DateInputWithPopup);

exports.default = _default;